import React from "react";
import { Card, CardContent } from "./ui/card";
import { MapPin, Calendar, Shield, Users, Clock, Heart } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: MapPin,
      title: "Flexible Locations",
      description: "We operate across all major areas and are flexible with pickup and drop-off locations to suit your needs.",
      color: "from-yellow-50 to-amber-50",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    },
    {
      icon: Calendar,
      title: "Any Occasion",
      description: "Whether it's a night out, corporate event, wedding, or party - we cater to all occasions with professional service.",
      color: "from-amber-50 to-yellow-50",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700"
    },
    {
      icon: Shield,
      title: "Safe Journey Home",
      description: "Your safety is our top priority. Our experienced drivers ensure you reach home safely, every single time.",
      color: "from-yellow-50 to-white",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    },
    {
      icon: Users,
      title: "Experienced Drivers",
      description: "All our drivers have minimum 2 years experience and hold valid Class 3/3A licenses for your peace of mind.",
      color: "from-white to-yellow-50",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700"
    },
    {
      icon: Clock,
      title: "Extended Hours",
      description: "Operating from 9PM to 4AM daily, we're here when you need us most, especially during late night hours.",
      color: "from-amber-50 to-white",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    },
    {
      icon: Heart,
      title: "Customer Relationships",
      description: "We don't just provide rides - we build lasting relationships by understanding your preferences and needs.",
      color: "from-yellow-50 to-amber-50",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700"
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Professional valet and drive home services tailored to your needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className={`border-2 border-yellow-200 shadow-lg hover:shadow-2xl transition-shadow overflow-hidden card-hover bg-gradient-to-br ${service.color}`}
              >
                <CardContent className="p-8">
                  <div className={`w-14 h-14 ${service.iconBg} rounded-xl flex items-center justify-center mb-6`}>
                    <Icon className={`w-7 h-7 ${service.iconColor}`} />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
